import { render, staticRenderFns } from "./LegalitasBU.vue?vue&type=template&id=f59da68a&"
import script from "./LegalitasBU.vue?vue&type=script&lang=js&"
export * from "./LegalitasBU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports